<div [modus-tooltip]="progress().tooltip" class="relative">
  <div class="w-5 h-5 absolute border-2 border-gray-1 rounded-full"></div>
  <mat-progress-spinner
    class="!w-5 !h-5 relative"
    mode="determinate"
    [value]="progress().percentageComplete"
  >
  </mat-progress-spinner>
</div>
